import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { useLeadModal } from "@/context/LeadModalContext";
import { scrollToId } from "@/hooks/useLenis";

const LINKS = [
  { label: "Come funziona", id: "#come-funziona" },
  { label: "Catalogo", id: "#catalogo" },
  { label: "Per chi è", id: "#per-chi" },
  { label: "FAQ", id: "#faq" },
];

export const Header = () => {
  const { openModal } = useLeadModal();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setMenuOpen(false);
    setTimeout(() => scrollToId(id), 10);
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-ivory/85 backdrop-blur-md border-b hairline" : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 h-16 sm:h-[72px] flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-brand-logo"
          onClick={(e) => { e.preventDefault(); go("#top"); }}
          className="flex items-center"
        >
          <img src="/logo-mbo.png" alt="My Brand Online" className="h-5 sm:h-6 w-auto" />
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {LINKS.map((l) => (
            <a
              key={l.id}
              href={l.id}
              data-testid={`nav-link-${l.id.slice(1)}`}
              onClick={(e) => { e.preventDefault(); go(l.id); }}
              className="font-sans-ui text-[13px] tracking-wide text-ink/70 hover:text-ink transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="nav-cta-request-access"
            onClick={openModal}
            className="hidden sm:inline-flex items-center bg-ink text-ivory px-6 py-3 text-[11px] tracking-mega font-medium hover:bg-charcoal transition-colors duration-300"
          >
            RICHIEDI ACCESSO
          </button>
          <button
            className="lg:hidden p-2 -mr-2 text-ink"
            aria-label="Menu"
            data-testid="mobile-menu-toggle"
            onClick={() => setMenuOpen((v) => !v)}
          >
            {menuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-ivory border-t hairline px-5 py-6 space-y-1" data-testid="mobile-menu">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`mobile-nav-link-${l.id.slice(1)}`}
              onClick={() => go(l.id)}
              className="block w-full text-left font-display text-2xl py-2 text-ink"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="mobile-nav-cta-request-access"
            onClick={() => { setMenuOpen(false); openModal(); }}
            className="mt-4 w-full bg-ink text-ivory py-4 text-[11px] tracking-mega font-medium"
          >
            RICHIEDI ACCESSO
          </button>
        </div>
      )}
    </header>
  );
};
